/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useMemo } from 'react';
import { usePopperTriggerLogic } from './usePopperTriggerLogic.js';
import { useCurrentDisplayedWheelsLogic } from './useCurrentDisplayedWheelsLogic.js';
import { useKeyboardHandlers } from './useKeyboardHandlers.js';

export type TimeWheelContextT = ReturnType<typeof useCurrentDisplayedWheelsLogic> &
  ReturnType<typeof usePopperTriggerLogic> &
  ReturnType<typeof useKeyboardHandlers>;

export const useConfigTimePickerCTX = (): TimeWheelContextT => {
  const currentDisplayedTimeWheelLogic = useCurrentDisplayedWheelsLogic();
  const popperLogic = usePopperTriggerLogic();
  const keyboardHandlers = useKeyboardHandlers({ currentDisplayedTimeWheelLogic });

  return useMemo(
    () => ({
      ...currentDisplayedTimeWheelLogic,
      ...popperLogic,
      ...keyboardHandlers,
    }),
    [currentDisplayedTimeWheelLogic, popperLogic, keyboardHandlers],
  );
};
